import { RequestService } from '../../../common/services/RequestService';
import { GET_SUBJECTS } from '../constants';

export const getSubjects = payload => {
  return RequestService.get(GET_SUBJECTS);
};
